import { Share2Icon } from "lucide-react";
import { PrimaryButton } from "../Buttons/PrimaryButton";

interface EntryFinishPopupProps {
  onClickShare: () => void;
  onClose: () => void;
}

export const EntryFinishPopup: React.FC<EntryFinishPopupProps> = ({ onClickShare, onClose }) => {
  return (
    <>
      <div className="w-full my-10 text-4xl font-bold text-center">エントリー完了!!</div>
      <div className="flex justify-center mb-10 mr-4">
        <img src="/assets/success-cat.png" alt="success-cat" width={198} />
      </div>

      {/* <div className="flex justify-center gap-[2px] relative">
        <div className="border-[2px] border-primary rounded-full px-3 py-[6px] flex items-center">
          <span className="text-primary text-sm font-bold">エントリーをシェアしたら</span>
          <img src="/assets/thumba-coin.svg" alt="coin" className="w-[13px] h-[13px] inline-block" />
          <span className="text-primary text-[15px] font-bold">
            <span className="text-[#FFA800] font-bold">10pt</span>
            獲得！
          </span>
        </div>
        <div className="absolute bottom-[-10px] right[50%]">
          <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">
            <path d="M6.5 12L0.00481036 0.749999L12.9952 0.75L6.5 12Z" fill="#176BF2" />
          </svg>
        </div>
      </div> */}
      <div className="px-4 my-4">
        <PrimaryButton
          content={
            <div className="flex items-center gap-2 text-white justify-center">
              <Share2Icon className="text-white w-5 h-5 cursor-pointer" />
              <span className="text-base font-bold">このクイズをシェアする</span>
            </div>
          }
          onClick={onClickShare}
          className="w-full bg-gradient-primary"
        />
      </div>

      <div className="text-center text-sm text-primary underline cursor-pointer mb-7" onClick={onClose}>
        閉じる
      </div>
    </>
  );
};
